export default __webpack_public_path__ + "static/media/Abhinav Chakravarty.976290fc.jpg";